import React from "react";
import "./LoadingSpinner.scss";

const LoadingSpinner = () => {
  return (
    <div className="loadingWrapper">
      <div className="loading">
        <div className="spinner-6"></div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
